import React from 'react';

const pagePropsContext = React.createContext<unknown>(undefined);

export interface PagePropsContextProps<T> {
  pageProps: T;
  children: React.ReactNode;
}

export function PagePropsContextProvider<T>({ pageProps, children }: PagePropsContextProps<T>) {
  const value = React.useMemo(
    () => { return pageProps },
    [pageProps]
  );
  return <pagePropsContext.Provider value={value}>{children}</pagePropsContext.Provider>;
}

export function usePageProps<T>() {
  const value = React.useContext(pagePropsContext) as T | undefined;
  if (value === undefined) {
    throw new Error('usePageProps must be used within a PagePropsContextProvider');
  }
  return value;
}
